import { Component, HostBinding, OnInit, ViewChild, ElementRef, HostListener } from '@angular/core';
import { Router, RouterLink, RouterLinkActive } from '@angular/router';
import { UserService } from '../services/user.service';
import { HttpErrorResponse } from '@angular/common/http';
import * as $ from 'jquery';
import { CookieService } from 'ngx-cookie-service';
import { OAuthService } from 'angular-oauth2-oidc';
import { environment } from '../../environments/environment';
import { NgbModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { CommunicationService } from '../services/communication.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { GeminiSessionService } from '../services/gemini-session.service';
import { PopoverService } from '../services/popoverService';
import { InsuranceHubService } from '../services/Insurance-hub.service';
import { CommonModule, NgIf } from '@angular/common';
import { TrackingDirective } from '../helpers/directive/tracking.directive';
import { NudgeService } from '../services/nudge.service';

@Component({
    selector: 'app-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.css'],
    standalone: true,
    imports: [TrackingDirective, RouterLink, NgIf, RouterLinkActive, CommonModule]
})
export class HeaderComponent implements OnInit {
  env = environment;
  @ViewChild('callbackConfirmationModel', { static: false }) callbackConfirmationModel: ElementRef;
  @ViewChild('LoginBackError', { static: false }) LoginBackError: ElementRef;
  @HostBinding('style.width') public readonly WIDTH = '100%';
  userData = null;
  title = 'webapp';
  callbackErrorMsg = '';
  callbackSuccessMsg = '';
  modalOptions: NgbModalOptions;
  dropdownVisible = false;
  UserPolicyDetails;
  showCoachmark = false;
  constructor(
    public router: Router,
    private cookieService: CookieService,
    private oauthService: OAuthService,
    private nudgeService: NudgeService,
    private modalService: NgbModal,
    private communicationService: CommunicationService,
    private spinner:NgxSpinnerService,
    private popoverService: PopoverService,
    private insuranceHubService: InsuranceHubService
  ) {
    this.modalOptions = {
      backdrop: 'static',
      backdropClass: 'customBackdrop'
    };
    document.addEventListener('click', () => {
      this.dropdownVisible = false;
    });
  }

  ngOnInit(): void {

    this.userData = this.oauthService.getIdentityClaims();
   if (!this.userData) {
       if (localStorage.getItem('apiUserModel')) {
          this.userData = JSON.parse(localStorage.getItem('apiUserModel'));
       } 
      }
      setTimeout(() => {
        if (this.userData!=null && this.userData.hasOwnProperty('name')) {
          this.GetPolicyDetails();
        }
      }, 500);
    this.bindNavBar();
    
    let type = this.cookieService.get('uType');
    if (type === '3') {
      $('#liFinancialWellness').show();

      var date = new Date();
      var hour = date.getUTCHours() + 2;
     
    } else {
      $('#liFinancialWellness').hide();
    }
  }

  GetPolicyDetails(){
        this.insuranceHubService.GetUserPolicyListWithDetails().subscribe({
        next: (data: any) => {
        this.UserPolicyDetails = data;
        }
    });
    const IsOnboardingJourney= sessionStorage.getItem('splOnBoardingVisited') || sessionStorage.getItem('capfinOnBoardingVisited');
     if (this.router.url === '/portal/dashboard' && !IsOnboardingJourney) {
       this.GetNudgeDetails();
  }else{
    sessionStorage.setItem('DashboardUserNudged', 'true');
  }
  }
 
  hasNudged(): boolean {
    return  sessionStorage.getItem('DashboardUserNudged') !== null;
  }

  GetNudgeDetails() {
    const hasNudged = this.hasNudged();
    if (hasNudged) {
      return;
    }
    this.nudgeService.GetNudgeDetails().subscribe((data: any) => {
      if (data == true) {
        this.showCoachmark = true;
        document.body.style.overflow = 'hidden';
        } else {
          this.showCoachmark = false;
          sessionStorage.setItem('DashboardUserNudged', 'true');
          sessionStorage.setItem('isNavfromNudgeClicked', 'false');
        }
      })
  }
  ToggleMobileMenuCoachmark(actionType){
    const isNavfromNudgeClicked =  sessionStorage.getItem('isNavfromNudgeClicked') === 'true';
       if (!isNavfromNudgeClicked) {
      return;
    }
    this.InsertOrUpdateNudge(actionType);
    sessionStorage.setItem('isNavfromNudgeClicked', 'false');
  }

  ToggleCoachmark(actiontype: number) {
    if (!this.showCoachmark) {
      return;
    }
    this.InsertOrUpdateNudge(actiontype);
  }

  InsertOrUpdateNudge(actiontype: number){
      this.showCoachmark = false;
      document.body.style.overflow = '';
      this.nudgeService.InsertOrUpdateNudgeDetails({ "action": actiontype }).subscribe({next: (data: any) => {
        if (data.status == 200) {
          sessionStorage.setItem('DashboardUserNudged', 'true');
          if (actiontype == 1) {
            this.router.navigate(['/portal/solutions']);
          }
      }
    }, error: (err: HttpErrorResponse) => {
      console.error('Error occurred while toggling coachmark:', err);
      document.body.style.overflow = '';
    }});
  }

  toggleDropdown(event: Event): void {
    event.stopPropagation();

    this.popoverService.clearPopover();

    // toggle dropdown
    this.dropdownVisible = !this.dropdownVisible;
  }
OpenNavbar(){
  $('body').toggleClass('push-menu-body');
  $('.navbar').toggleClass('push-menu-visible');
  this.showCoachmark=false;
  sessionStorage.setItem('DashboardUserNudged', 'true');
  sessionStorage.setItem('isNavfromNudgeClicked', 'true');

}

  bindNavBar() {
    const backDrop = '<div class="backdrop"></div>';
    $('.navbar-toggler').click(function () {
      $('body').toggleClass('push-menu-body');
      $('.navbar').toggleClass('push-menu-visible');
    });
    $('.navbar-close').click(function() {
    });
    $('.navbar-nav').click(function () {
      $('body').removeClass('push-menu-body');
      $('.navbar').removeClass('push-menu-visible');
    });
  }


  logout() {
    this.modalService.dismissAll();    
    const isNavfromNudgeClicked =  sessionStorage.getItem('isNavfromNudgeClicked') === 'true';
    if (isNavfromNudgeClicked) {
      this.ToggleMobileMenuCoachmark(0);
    }
    this.spinner.show();
    setTimeout(() => {
      (window as any).fcWidget.destroy();

      ///Note on remove Cookies or Storage:- What code you going to apply here for remove Keys, Must apply the same code in(app.component, auth.interceptor)
      this.cookieService.delete('submissionId', '/');
      this.cookieService.delete('uType', '/');
      this.cookieService.delete('userId', '/');
      this.cookieService.delete('authToken', '/');
      localStorage.removeItem('isLoginSuccess');
      sessionStorage.removeItem('sessionId');
      sessionStorage.removeItem('isRedirected');
      sessionStorage.clear();
      localStorage.clear();

      this.oauthService.logOut();
      this.spinner.hide();
    }, 1000);
  }

  checkLoginFired() {
    if (this.router.url == '/security-question') {
      localStorage.setItem('loginFired', 'true');
      this.modalService.open(this.LoginBackError, this.modalOptions);
    }
    else
      this.azureAdlogin();
  }

  redirectLogin() {
    this.modalService.dismissAll();
    this.azureAdlogin();
  }

  stopNavigation() { this.modalService.dismissAll(); }

  azureAdlogin() {
    let submissionId = '';
    if (sessionStorage.getItem('submissionId')) {
      submissionId = sessionStorage.getItem('submissionId');
    }
    let pageLoadTimestamp = Date.now();
    let trackingVisitorId = this.cookieService.get('visitorId');
    let trackingSessionId = sessionStorage.getItem('sessionId');
    console.log('trackingVisitorId', trackingVisitorId);
    console.log('trackingSessionId', trackingSessionId);
    this.oauthService.initLoginFlow('', {
      submissionId, ccAppUrl: window.location.origin,
      instrumentationKey: environment.appInsights.instrumentationKey, 
         ...(trackingVisitorId ? { trackingVisitorId: trackingVisitorId } : { trackingVisitorId: '' }),
        ...(trackingSessionId ? { trackingSessionId: trackingSessionId } : { trackingSessionId: '' }),
        ...(pageLoadTimestamp ? { loginTime: pageLoadTimestamp } : {})
    });
  }

  callbackPopup() {
    this.modalService.open(this.callbackConfirmationModel, this.modalOptions);
  }

  callback() {
    this.callbackErrorMsg = '';
    this.callbackSuccessMsg = '';
    this.communicationService.userCallback().subscribe({
        next: (data: any) => {
      this.callbackSuccessMsg = 'Our coach will contact you shortly';
    },
      error :(err: HttpErrorResponse) => {
        this.callbackErrorMsg = 'Error: Please try after some time';
      }});
  }

}

